const etoeProduction = {
  id: 5,
  slug: "etoe-production",

  title: "ETOE Production",

  description:
    "A premium portfolio website developed for a creative production studio to showcase photography, cinematography, and visual storytelling through a modern, responsive, and immersive web experience.",

  category: "Web Development",
  type: "Client Project",
  status: "Completed",
  year: "2026",

  timeline: "3 Months",

  developedBy: "Horyzen Technologies",

  role: "Frontend Development",

  technologies: [
    "React",
    "JavaScript",
    "CSS3",
    "React Router",
    "GSAP",
    "HTML5"
  ],

  image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1600&q=80",

  liveUrl: "",
  githubUrl: "",

  featured: true
};

export default etoeProduction;